import React, { useEffect, useState } from "react";
import "./SubDistributorsMenu.css";
import "../Orders/Orders.css";
import "../Inventory/Inventory.css";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";
import * as yup from "yup";
import TablePagination from "@mui/material/TablePagination";
import { FiEdit } from "react-icons/fi";

let addSubDistributorSchema = yup.object({
  business_name: yup.string().required("Business name is required"),
  contact_person: yup
    .string()
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
    .required("Contact person name is required"),
  pincode: yup.string().matches(/^[0-9]+$/, "Only numbers allowed"),
  state_code: yup.string().matches(/^[0-9]+$/, "allowed only numbers"),
  city: yup.string().matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  district: yup.string().matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  state: yup.string().matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),

  user: yup.object({
    phone_number: yup
      .string()
      .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
      .required("Phone number is required"),

    email: yup
      .string()
      .email("Enter a valid email address")
      .required("Email is required"),
    password: yup.string().required("Password is required"),
  }),
});

let editSubDistributorSchema = yup.object({
  business_name: yup.string().required("Business name is required"),
  contact_person: yup
    .string()
    .matches(/^[A-Za-z\s]+$/, "Only letters are allowed")
    .required("Contact person name is required"),
  pincode: yup.string().matches(/^[0-9]+$/, "Only numbers allowed"),
  state_code: yup.string().matches(/^[0-9]+$/, "allowed only numbers"),
  city: yup.string().matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  district: yup.string().matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),
  state: yup.string().matches(/^[A-Za-z\s]+$/, "Only letters are allowed"),

  user: yup.object({
    phone_number: yup
      .string()
      .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
      .required("Phone number is required"),

    email: yup
      .string()
      .email("Enter a valid email address")
      .required("Email is required"),
    // password: yup.string().required("Password is required"),
  }),
});

export const SubDistributors = () => {
  const [loading, setLoading] = useState(false);
  const [subdistributorData, setSubDistributorData] = useState({});
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  // add modal
  const [addshow, setAddShow] = useState(false);

  const handleAddClose = () => {
    formik.resetForm(); //clears values, errors, touched
    setAddShow(false);
  };
  const handleAddShow = () => setAddShow(true);

  // edit modal
  const [editshow, setEditShow] = useState(false);
  const [editId, setEditId] = useState("");

  const handleEditClose = () => {
    editformik.resetForm(); //clears values, errors, touched
    setEditShow(false);
  };
  const handleEditShow = (id) => {
    setEditShow(true);
    setEditId(id);
    FetchEachSubdistributor(id);
  };

  // table pagination
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_sub_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_sub_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [totalCount, setTotalCount] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // reset to first page
    sessionStorage.setItem("dis_sub_rowsPerPage", +event.target.value);
    sessionStorage.setItem("dis_sub_page", 0);
  };

  // const [filterToggler, setFilterToggler] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  function handleClearFilters() {
    // setFilterToggler("");
    setSearchQuery("");
    setSelectedLabel("");
  }
  function handleReset() {
    setSearchQuery("");
  }
  async function fetchSubdistributorData() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1, // atleast 1 page
          page_size: rowsPerPage,
          search: searchQuery || "",
          date: selectedLabel || "",
        },
      };
      const response = await axiosInstance.get(
        "/distributor/subdistributor/list/",
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setSubDistributorData(response.data.data);
        setTotalCount(response.data?.data.count);
        console.log("Sub distributor data fetched successfully!");
      }
    } catch (error) {
      toast.error("Failed to fetch subdistributor details!");
      console.log("Failed to fetch subdistributor details!");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchSubdistributorData();
  }, [page, rowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (page !== 0) {
        setPage(0);
      } else {
        fetchSubdistributorData();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, selectedLabel]);

  const formik = useFormik({
    initialValues: {
      contact_person: "",
      business_name: "",
      address: "",
      city: "",
      district: "",
      state: "",
      pincode: "",
      state_code: "",

      user: {
        phone_number: "",
        email: "",
        password: "",
      },
    },
    validationSchema: addSubDistributorSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const response = await axiosInstance.post(
          "/distributor/subsitributor/create/",
          values,
        );
        if (response.data.status === "Success" || response.status === 200) {
          resetForm();
          handleAddClose();
          fetchSubdistributorData();
          toast.success(
            response.data.message || "Subdistributor added successfully!",
          );
          console.log("Subdistributor added successfully!");
        }
      } catch (error) {
        toast.error(
          error.response.data.message || "Failed to add subdistributor",
        );
        console.log("Failed to add subdistributor");
      } finally {
        setLoading(false);
      }
    },
  });

  // edit sub distributor
  async function FetchEachSubdistributor(id) {
    try {
      const response = await axiosInstance.get(
        `distributor/subdistributor-update/${id}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        const data = response.data.data;

        editformik.setValues({
          contact_person: data.contact_person || "",
          business_name: data.business_name || "",
          address: data.address || "",
          city: data.city || "",
          district: data.district || "",
          state: data.state || "",
          pincode: data.pincode || "",
          state_code: data.state_code || "",
          user: {
            phone_number: data.user?.phone_number || "",
            email: data.user?.email || "",
            password: "",
          },
        });
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch data");
      console.log("Failed to fetch data");
    } finally {
    }
  }
  const editformik = useFormik({
    initialValues: {
      contact_person: "",
      business_name: "",
      address: "",
      city: "",
      district: "",
      state: "",
      pincode: "",
      state_code: "",

      user: {
        phone_number: "",
        email: "",
        password: "",
      },
    },
    validationSchema: editSubDistributorSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const response = await axiosInstance.patch(
          `/distributor/subdistributor-update/${editId}/`,
          values,
        );
        if (response.data.status === "Success" || response.status === 200) {
          resetForm();
          handleEditClose();
          fetchSubdistributorData();
          toast.success(
            response.data.message || "Subdistributor Updated successfully!",
          );
          console.log("Subdistributor Updated successfully!");
        }
      } catch (error) {
        toast.error(
          error.response.data.message || "Failed to update subdistributor",
        );
        console.log("Failed to update subdistributor");
      } finally {
        setLoading(false);
      }
    },
  });
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="ordersContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">Sub-distributors</div>
              <div className="inventorySubtitle">
                Manage your sub-distributors, their stock, and orders.
              </div>
            </div>

            <div className="addButtonContainer">
              <div className="inventoryBtnReorder">
                <button onClick={handleAddShow}>+ Add Sub-distributor</button>
              </div>
            </div>
          </div>

          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              {/* <div>
                <div className="dropdownTitle">Filter by</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {filterToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setFilterToggler("")}>
                      All
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => setFilterToggler("Payment Type")}
                    >
                      Payment Type
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => setFilterToggler("Status")}>
                      Status
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {(searchQuery || selectedLabel) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of{" "}
                </span>
                {searchQuery && (
                  <>
                    {" "}
                    &nbsp; <strong>Search:</strong> {searchQuery}{" "}
                  </>
                )}
                {selectedLabel && (
                  <>
                    {" "}
                    &nbsp; <strong>Date:</strong> {selectedLabel}{" "}
                  </>
                )}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                {" "}
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          {/* cards section  */}
          <div className="subDistCardsGrid">
            <div className="inventoryCard">
              <div>Total Sub-Distributors</div>
              <div>
                {subdistributorData?.SubDistributor_card?.total_subdistributor}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Active Orders</div>
              <div style={{ color: "var(--color-btn-background)" }}>
                {subdistributorData?.SubDistributor_card?.active_orders}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Pending Payments</div>
              <div>
                {subdistributorData?.SubDistributor_card?.pending_payment}
              </div>
            </div>
          </div>
          {/* table  */}
          <div className="titleOrderList">Sub-distributors List</div>

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Business Name</TableCell>
                    <TableCell align="left">Location</TableCell>
                    <TableCell align="left">Contact Person</TableCell>
                    <TableCell align="left">Phone</TableCell>
                    <TableCell align="left">Total Orders</TableCell>
                    <TableCell align="left">Outstanding Dues (₹)</TableCell>
                    <TableCell align="left">Last Order Date</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subdistributorData?.results?.length > 0 ? (
                    subdistributorData.results.map((row) => (
                      <TableRow
                        key={row.phone_number || "---"}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">
                          {row.business_name || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {/* {row.location || "---"} */}
                          {row.city || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.contact_person || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.phone_number || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.total_orders || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.outstanding_dues || "---"}
                        </TableCell>
                        <TableCell align="left">
                          {row.last_order_date || "---"}
                        </TableCell>
                        {/* <TableCell align="left">
                          <IoEyeOutline
                            onClick={() =>
                              navigate("/state-view-subDistributors", {
                                state: { Id: row.id },
                              })
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </TableCell> */}
                        <TableCell align="left">
                          <div className="d-flex gap-3">
                            <span
                              onClick={() =>
                                navigate("/state-view-subDistributors", {
                                  state: { Id: row.id },
                                })
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <IoEyeOutline />
                            </span>
                            <span
                              onClick={() => handleEditShow(row.id)}
                              style={{ cursor: "pointer" }}
                            >
                              <FiEdit />
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={(event, newPage) => {
                setPage(newPage);
                sessionStorage.setItem("dis_sub_page", newPage);
              }}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>

        {/* add product modal  */}
        <div>
          <Modal
            show={addshow}
            onHide={handleAddClose}
            centered
            size="lg"
            className="addModal"
          >
            <form onSubmit={formik.handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Add New Sub-distributor
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addModalGrid">
                  <div>
                    <label>
                      Business Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Business Name"
                      name="business_name"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.business_name}
                    />
                    {formik.errors.business_name &&
                      formik.touched.business_name && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.business_name}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>
                      Contact Person Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Contact person name"
                      name="contact_person"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.contact_person}
                    />
                    {formik.errors.contact_person &&
                      formik.touched.contact_person && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.contact_person}
                        </div>
                      )}
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="Enter Phone Number"
                      name="user.phone_number"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.user?.phone_number}
                    />
                    {formik.errors.user?.phone_number &&
                      formik.touched.user?.phone_number && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.user?.phone_number}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>
                      Email Address <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      placeholder="Enter Email Address "
                      name="user.email"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.user?.email}
                    />
                    {formik.errors.user?.email &&
                      formik.touched.user?.email && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.user?.email}
                        </div>
                      )}
                  </div>
                </div>
                <div className="addModalGrid">
                  <div>
                    <label>Address</label>
                    <input
                      type="text"
                      placeholder="Enter Address"
                      name="address"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                    />
                    {formik.errors.address && formik.touched.address && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {formik.errors.address}
                      </div>
                    )}
                  </div>
                  <div>
                    <label>City</label>
                    <input
                      type="text"
                      placeholder="Enter City"
                      name="city"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.city}
                    />
                    {formik.errors.city && formik.touched.city && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {formik.errors.city}
                      </div>
                    )}
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>District</label>
                    <input
                      type="text"
                      placeholder="Enter District"
                      name="district"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.district}
                    />
                    {formik.errors.district && formik.touched.district && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {formik.errors.district}
                      </div>
                    )}
                  </div>
                  <div>
                    <label>State</label>
                    <input
                      type="text"
                      placeholder="Enter State"
                      name="state"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.state}
                    />
                    {formik.errors.state && formik.touched.state && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {formik.errors.state}
                      </div>
                    )}
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>Pin Code</label>
                    <input
                      type="text"
                      placeholder="Enter Pin Code"
                      name="pincode"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.pincode}
                    />
                    {formik.errors.pincode && formik.touched.pincode && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {formik.errors.pincode}
                      </div>
                    )}
                  </div>
                  <div>
                    <label>State Code</label>
                    <input
                      type="text"
                      placeholder="Enter State Code"
                      name="state_code"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.state_code}
                    />
                    {formik.errors.state_code && formik.touched.state_code && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {formik.errors.state_code}
                      </div>
                    )}
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>
                      Password <span className="text-danger">*</span>
                    </label>
                    <input
                      type="password"
                      placeholder="Enter Password"
                      name="user.password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.user?.password}
                    />
                    {formik.errors.user?.password &&
                      formik.touched.user?.password && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.user?.password}
                        </div>
                      )}
                  </div>
                  <div>{""}</div>
                </div>

                <div className="addModalTextGrid">
                  <div>
                    <label>Address</label>
                  </div>
                  <div>
                    <textarea
                      placeholder="Enter Address"
                      rows={4}
                      name="address"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                    ></textarea>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="addBtnCancel"
                  onClick={handleAddClose}
                >
                  Cancel
                </button>
                <button className="addBtnSave" type="submit">
                  {" "}
                  Save Details
                </button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
        {/* edit modal  */}
        <div>
          <Modal
            show={editshow}
            onHide={handleEditClose}
            centered
            size="lg"
            className="addModal"
          >
            <form onSubmit={editformik.handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Edit Sub-distributor
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addModalGrid">
                  <div>
                    <label>
                      Business Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Business Name"
                      name="business_name"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.business_name}
                    />
                    {editformik.errors.business_name &&
                      editformik.touched.business_name && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.business_name}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>
                      Contact Person Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Contact person name"
                      name="contact_person"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.contact_person}
                    />
                    {editformik.errors.contact_person &&
                      editformik.touched.contact_person && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.contact_person}
                        </div>
                      )}
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="Enter Phone Number"
                      name="user.phone_number"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.user?.phone_number}
                    />
                    {editformik.errors.user?.phone_number &&
                      editformik.touched.user?.phone_number && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.user?.phone_number}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>
                      Email Address <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      placeholder="Enter Email Address "
                      name="user.email"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.user?.email}
                    />
                    {editformik.errors.user?.email &&
                      editformik.touched.user?.email && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.user?.email}
                        </div>
                      )}
                  </div>
                </div>
                <div className="addModalGrid">
                  <div>
                    <label>Address</label>
                    <input
                      type="text"
                      placeholder="Enter Address"
                      name="address"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.address}
                    />
                    {editformik.errors.address &&
                      editformik.touched.address && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.address}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>City</label>
                    <input
                      type="text"
                      placeholder="Enter City"
                      name="city"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.city}
                    />
                    {editformik.errors.city && editformik.touched.city && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {editformik.errors.city}
                      </div>
                    )}
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>District</label>
                    <input
                      type="text"
                      placeholder="Enter District"
                      name="district"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.district}
                    />
                    {editformik.errors.district &&
                      editformik.touched.district && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.district}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>State</label>
                    <input
                      type="text"
                      placeholder="Enter State"
                      name="state"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.state}
                    />
                    {editformik.errors.state && editformik.touched.state && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {editformik.errors.state}
                      </div>
                    )}
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>Pin Code</label>
                    <input
                      type="text"
                      placeholder="Enter Pin Code"
                      name="pincode"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.pincode}
                    />
                    {editformik.errors.pincode &&
                      editformik.touched.pincode && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.pincode}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>State Code</label>
                    <input
                      type="text"
                      placeholder="Enter State Code"
                      name="state_code"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.state_code}
                    />
                    {editformik.errors.state_code &&
                      editformik.touched.state_code && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.state_code}
                        </div>
                      )}
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>
                      Password
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <input
                      type="password"
                      placeholder="Enter Password"
                      name="user.password"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.user?.password}
                    />
                    {editformik.errors.user?.password &&
                      editformik.touched.user?.password && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {editformik.errors.user?.password}
                        </div>
                      )}
                  </div>
                  <div>{""}</div>
                </div>

                <div className="addModalTextGrid">
                  <div>
                    <label>Address</label>
                  </div>
                  <div>
                    <textarea
                      placeholder="Enter Address"
                      rows={4}
                      name="address"
                      onChange={editformik.handleChange}
                      onBlur={editformik.handleBlur}
                      value={editformik.values.address}
                    ></textarea>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="addBtnCancel"
                  onClick={handleEditClose}
                >
                  Cancel
                </button>
                <button className="addBtnSave" type="submit">
                  {" "}
                  Update
                </button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    </>
  );
};
